import { render, staticRenderFns } from "./SuficienciaSidebar.vue?vue&type=template&id=57fc6d0a&"
import script from "./SuficienciaSidebar.vue?vue&type=script&lang=js&"
export * from "./SuficienciaSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports